import { create } from 'zustand';

import { createSbSdkWrapper, type common } from '../sdk'
import { host } from '@smokeballdev/smokeball-client-sdk'

type SmokeballSdkStore = {
  isLoading: boolean
  isAvailable: boolean
  sdk?: common.Api
  smokeballVersion?: host.Version
  isSmokeballNative: boolean
  isSmokeballWeb: boolean
  isEmbedded: boolean
}

export const useSmokeballSdkStore = create<SmokeballSdkStore>(() => ({
  isLoading: true,
  isAvailable: false,
  sdk: undefined,
  smokeballVersion: undefined,
  isSmokeballNative: false,
  isSmokeballWeb: false,
  isEmbedded: false,
}));

export async function initSmokeballSdkStore() {
  try {
    const sdk = createSbSdkWrapper();
    
    if (sdk) {
      await sdk.init({ clientId: process.env.NEXT_PUBLIC_SDK_CLIENT_ID })
      
      const version = await sdk.host.version()
      const hostType = sdk?.host.type()
      
      const newState = {
        sdk,
        smokeballVersion: version,
        isAvailable: true,
        isLoading: false,
        isSmokeballNative: hostType === host.HostType.Native,
        isSmokeballWeb: hostType === host.HostType.Web,
        isEmbedded: hostType !== host.HostType.Unknown,
      }
      useSmokeballSdkStore.setState(newState)
    } else {
      useSmokeballSdkStore.setState({ isLoading: false })
    }
  } catch (error) {
    console.error('[SMOKEBALL-SDK] Error initializing SDK:', error);
    useSmokeballSdkStore.setState({ 
      isLoading: false, 
      isAvailable: false, 
      sdk: undefined 
    })
  }
}

